import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/_route/teams/$teamId/candidates/$candidateId/',
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      params,
      search,
      to: '/teams/$teamId/candidates/$candidateId/activity',
    });
  },
});
